import styled from 'styled-components';

interface IContainer {
  $flexGrow?: boolean;
  displayFlex?: boolean;
}

const Container = styled.div<IContainer>`
  //actual max-width = 1330px
  max-width: 1450px;
  margin: 0px auto;
  padding: 0 60px;
  height: 100%;
  width: 100%;
  flex-grow: ${(props: IContainer) => (props.$flexGrow ? '1' : '0')};
  display: ${(props: IContainer) => (props.displayFlex ? 'flex' : 'block')};

  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    max-width: 1386px;
    padding: 0 28px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    max-width: 1370px;
    padding: 0 20px;
  }
`;

export default Container;
